module.exports = __webpack_public_path__ + "static/media/teygja_utanverdlaeri_a.ee03020c.png";